import { UserNotificationInfo } from "common-util-experience-client";
import { formatPassTime } from "../helper/dateFormatter";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { UsersApi } from "users-experience-client";
import { createUsersApi } from "../api-helpers/UserApiHelper";

interface Props {
  notification: UserNotificationInfo;
  onDeleteClicked: () => void;
  onCloseModalTrigger: () => void
}

const userApi: UsersApi = createUsersApi();

const Notification = ({ notification, onDeleteClicked, onCloseModalTrigger }: Props) => {

  const [initials, setInitials] = useState<string>();

  useEffect(() => {
    if (!notification) {
      return;
    }

    userApi.usersControllerFindOne(notification.createdBy).then(user => {
      const initials = user.data.firstName.substring(0, 1).toUpperCase() + (user.data.lastName?.substring(0, 1) ?? "");
      setInitials(initials);
    });
  }, [notification])

  const createHttpLink = () => {
    switch (notification.refType.toLowerCase()) {
      case "task":
        return "/tasks?selectedId=" + notification.refIds;
      default:
        return "#";
    }
  }

  const handleClick = () => {
    switch (notification.refType.toLowerCase()) {
      case "task":
        onCloseModalTrigger();
        break;
    }
  }

  return (
    <Link
      className="d-flex p-1 py-2 notification-card border-bottom border-gray"
      to={createHttpLink()}
      onClick={handleClick}
    >
      <span className="d-block user-icon me-2">{initials}</span>

      <span className="flex-fill d-flex flex-column gap-1">
        <span className="d-flex ">
          <span className="fw-medium flex-fill">{notification.title}</span>
          <span className="ms-2 fs-11 text-light" onClick={onDeleteClicked}>
            <span className="material-symbols-outlined fs-20 align-text-top">
              delete
            </span>
          </span>
        </span>

        <span className="d-block fs-13">{notification.message}</span>

        {/* Matrix Badges */}
        {/* {notification.matrix && (
                    <span className="d-flex">
                      {notification.matrix.map((item: any) => (
                        <span
                          key={item.type}
                          className={`badge bg-${item.color} fw-normal align-text-top me-1`}
                        >
                          {item.type + ": " + item.reading + " " + item.unit}
                        </span>
                      ))}
                    </span>
                  )} */}

        {/* Time Duration */}
        <span className="fs-12 text-light">
          <span className="material-symbols-outlined fs-14 align-text-top">
            schedule
          </span>{" "}
          {formatPassTime(notification.createdOn)} ago
        </span>
      </span>
    </Link>
  );
};

export default Notification;